import {load, addLink} from './common';

declare const data: string[];

load('./data/index.js', () => {
	const container = document.getElementById('container')!;
	for (const lang of data) {
		const div = document.createElement('div');
		const a = document.createElement('a');
		a.href = `./wiki.html?lang=${lang}`;
		a.textContent = `${lang}wiki`;
		div.append(a);
		container.append(div);
	}
});
